import React, { createContext, ReactNode } from 'react';
import { LLMProject, LLMUser } from '../API';

export interface UserContextType {
  user: LLMUser|null | undefined;
  setUser: (user: LLMUser | undefined) => void;
  project: LLMProject | undefined;
  projects: LLMUser[] | undefined;
  entitlements: string[] | undefined;
  subscriptionActive: boolean;
  trialDaysRemaining: number;
}


export const UserContext = createContext<UserContextType | undefined>(undefined);

interface UserProviderProps {
    children: ReactNode;
    user: LLMUser | null | undefined; 
    setUser: (user: LLMUser | undefined ) => void;
    project: LLMProject | undefined;
    projects: LLMUser[] | undefined;
    entitlements: string[] | undefined;
    subscriptionActive: boolean;
    trialDaysRemaining: number;
  }
  
  export const UserProvider: React.FC<UserProviderProps> = ({ children, user, setUser, project, projects, entitlements, subscriptionActive, trialDaysRemaining }) => {
    return (
      <UserContext.Provider value={{ user, setUser, project, projects, entitlements, subscriptionActive, trialDaysRemaining }} >
        {children}
      </UserContext.Provider>
    );
  };